interface inputProps {
    latitude: number;
    longitude: number;
    structureType: 'sat' | 'fixed' | 'eastWest';
    peakCapacity: number;
    specificCapex: number;
    specificOpex: number;
    returnRate: number;
    firstName: string;
    lastName: string;
    email: string;
}

interface outputProps {
    [key: string]: any;
}

export async function onSubmitCalculator(
    input: inputProps,
): Promise<outputProps> {
    const response = await triggerPowerAutomate(input);
    return response;
}

async function triggerPowerAutomate(input: outputProps) {
    const URL =
        process.env.GATSBY_LCOE_FLOW_URL ??
        'https://prod-11.westus.logic.azure.com:443/workflows/88fc6c6ffc5e40cc960efb3aa6347cbc/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=f6ZdRibyzkWK6VpEUz02Obv30Ishu3ohd_TUDet2sLQ';

    const response = await fetch(URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(input),
    });

    return response;
}
